import type { ExtractPropTypes, PropType } from 'vue'
export type StatusType = 'success' | 'warning' | 'error' | 'info' | 'loading' | 'processing' | string
export const statusProps = {
  type: {
    type: String as PropType<StatusType>,
    default: 'success'
  }
}

export type StatusProps = ExtractPropTypes<typeof statusProps>
